import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { CLessonInCourse, GetLessonsParams } from '../../../typings';

export function getLessons(
    courseId: number,
    params: GetLessonsParams
): Promise<{ clessons: Array<CLessonInCourse>, sortKey: string | null }> {
    const { apiGetLessons } = apiConfig.getStaticUrls();
    const serverParams = {
        list_type: params.type,
        page_size: params.pageSize,
        sort_key: params.sortKey,
    };

    return getFetch(`${apiGetLessons}${courseId}/`, serverParams);
}
